import { Component, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SubjectService } from "@core/services/subject.service";
import { first, takeUntil } from "rxjs/operators";
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { User } from "@core/models";
import { AuthenticationService } from "@core/services/auth";
import { Subject, Subscription } from "rxjs";
import Swal from "sweetalert2";
import { PaymentService } from "@core/services/payment.service";
import { SubscriptionService } from "@core/services/subscription.service";

@Component({
  standalone: false,
  selector: "app-quiz-page",
  templateUrl: "./quiz-page.component.html",
  styleUrls: ["./quiz-page.component.scss"],
})
export class QuizPageComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject();
  quizForm: UntypedFormGroup;
  selectedSubject: any;
  subjects: Array<any>;
  topics: Array<any>;
  form: Array<any> = [1, 2, 3, 4];
  ColumnMode = ColumnMode;
  quizData: any[] = [];
  currentUser: User;
  templateRef: TemplateRef<any>;
  context: any;
  studentId: number;
  studentForm: number;
  isStudent: boolean;
  isSubscribed: boolean;
  subjectId: any

  constructor(
    private fb: UntypedFormBuilder,
    private _subjectsService: SubjectService,
    private _authenticationService: AuthenticationService,
    private paymentService: PaymentService,
    private router: Router,
    private route: ActivatedRoute,
    private subscriptionService: SubscriptionService  ) {}

  ngOnInit(): void {
    this.subjectId = this.route.snapshot.paramMap.get('id');
    this.getStudentDetails();

    this.quizForm = this.fb.group({
      form: ["", Validators.required],
      subject: ["", Validators.required],
      topic: ["", Validators.required],
    });

    this.loadSubjects();
    this.getUserSubscriptionData();
  }

  getUserSubscriptionData(): void {
    this.subscriptionService
      .getUserSubscriptionDetails()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.isSubscribed =
            res?.subscription?.subscribed ||
            res?.contentSelection?.allowTrial || res.trialDTO.trialActive;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getStudentDetails(): void {
    this.currentUser = this._authenticationService.currentUserValue;
    this.isStudent = (this.currentUser.role === 30 || this.currentUser.role === 31) ? true : false;

    if (this.isStudent) {
      this.studentId = this.currentUser.userId;
      this.studentForm = this.currentUser.form;
    }
  }

  loadSubjects() {
    this._subjectsService.getSubjectsWithContent().subscribe((res: any) => {
      this.subjects = res;
      if(this.subjectId) {
        this.preselectSubject();
      }
    });
  }

  fetchTopics() {
    if (
      this.quizForm.value.subject == undefined ||
      this.quizForm.value.form == undefined
    ) {
      return;
    }

    this._subjectsService
      .getTopicsBySubjectAndForm(
        this.quizForm.value.subject,
        this.quizForm.value.form
      )
      .pipe(first())
      .subscribe((res: Array<any>) => {
        this.topics = res;
      });
  }

  onSubmit() {
    if (this.quizForm.invalid) {
      return;
    }
    this.router.navigate([
      "/quiz",
      Number(this.quizForm.value.topic),
      "subject",
      this.quizForm.value.subject,
      "form",
      this.quizForm.value.form,
    ]);
  }

  triggerSubscriptionAlert(): void {
    Swal.fire({
      title: "You are trying to access premium content",
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
      confirmButtonText: "Upgrade",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.paymentService.updatePaymentEvt();
      }
    });
  }

  messages = {
    emptyMessage: `
      <div class="text-center mt-3">
        <h5>You haven’t done a quiz yet.</h4>
        <p>Pick a quiz above  and complete it to view your results here.</p>
      </div>
    `,
  };

  preselectSubject(): void {
    this.quizForm.get('subject').setValue(this.subjectId)
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
